<button
    type="button"
    class="btn file-download"
    [title]="title"
    (click)="downloadFile()"
>
    <span class="file-download__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
             fill="none" stroke="white" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    </span>
    <span class="file-download__name">{{ title }}</span>
</button>
